import {stringUnion} from '@dv/shared/code';

export const COLOR_MODE = stringUnion('normal', 'bright', 'contrast', 'guide');

export type ColorMode = typeof COLOR_MODE.type;
